import { JsonObject, JsonProperty } from "typescript-json-serializer";

/**
 * *Geo.js Class*
 */
@JsonObject()
export class MessageConfiguration {
    @JsonProperty()
    declare class?: "info" | "positive" | "success" | "warning" | "negative" | "error" |
    "red" |
    "orange" |
    "yellow" |
    "olive" |
    "green" |
    "teal" |
    "blue" |
    "violet" |
    "purple" |
    "pink" |
    "brown" |
    "black" |
    "blank";
    @JsonProperty()
    declare condition?: string;

    @JsonProperty()
    declare content: string;

    @JsonProperty()
    declare title?: string;

    constructor() {}
}
